import linkedinIcon from '../../assets/images/linkedin.png'
import twitterIcon from '../../assets/images/twitter.png'
import facebookIcon from '../../assets/images/facebook.png'
import profileIcon from '../../assets/images/profile-male.svg'
export const JuryProfileCard = ({ name, designation }) => {
    return (
        <div className="card card-profile">
            <div className="card-body">
                <div className="profile-image-wrapper">
                    
                        <div className="starshot-ring">
                            <div className="avatar">
                                <div className="text-icon font-lato font-32 w-50p h-50p">{name[0]}</div>
                            </div>
                        </div>

                    
                </div>
                <h3>{name}</h3>
                <h6 className="opacity-50">{designation}</h6>
                <div className="d-flex justify-content-between align-items-center mt-2 p-2">
                    <div>
                        <img
                            src={linkedinIcon}
                            alt="img"
                            width={18}
                            height={18}
                        />
                    </div>
                    <div>
                        <img
                            src={twitterIcon}
                            alt="img"
                            width={18}
                            height={18}
                        />
                    </div>
                    <div>
                        <img
                            src={facebookIcon}
                            alt="img"
                            width={18}
                            height={18}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}